webpackJsonp([6],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),

/***/ "0+am":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certification@2x.b42e1c6.png";

/***/ }),

/***/ "0GbP":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('jin-dialog', {
    attrs: {
      "custom-class": "ushk-report-dialog",
      "size": "large",
      "width": "80%"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "ushk-report-dialog__title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.visible) ? _c('report-content', {
    attrs: {
      "type": _vm.type,
      "data": _vm.data,
      "border": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3I1u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_utils__ = __webpack_require__("j+bc");




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tabActive: 'us',
      curData: null,
      curType: null,
      isShowDialog: false,
      initHkTab: false
    };
  },

  watch: {
    tabActive: function tabActive(v) {
      if (!this.initHkTab && v === 'hk') {
        this.initHkTab = true;
      }
    }
  },
  methods: {
    showReport: function showReport(_ref) {
      var data = _ref.data,
          type = _ref.type;

      this.curData = data;
      this.curType = type;
      this.isShowDialog = true;
    }
  }
});

/***/ }),

/***/ "3Jun":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cooperation.40575e9.jpg";

/***/ }),

/***/ "3sgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("DfDl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules__ = __webpack_require__("mdX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("HapT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_utils__ = __webpack_require__("j+bc");








var vm = null;

var init = function init() {
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3__modules__["a" /* default */]);
  window.JIN10_APP.VueComponents(__WEBPACK_IMPORTED_MODULE_0_vue___default.a);
  vm = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a },
    template: '<App/>',
    store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */],
    el: '#J_ushk'
  });
};

if (false) {
  window.Vue = Vue;
  addScript('//cdn.jin10.com/assets/js/vue-components/js/index.js', function () {
    init();
  });
} else {
  init();
}

/***/ }),

/***/ "4R6w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-1.df1ecde.png";

/***/ }),

/***/ "5FRL":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-table",
    class: {
      'is-border': _vm.border
    }
  }, [_c('div', {
    staticClass: "ushk-table-head"
  }, [_c('div', {
    attrs: {
      "data-type": "fixed"
    }
  }, [_c('div', {
    staticClass: "ushk-table-head_wrap"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ushk-table-head_item",
      style: ({
        width: item[1]
      })
    }, [_vm._v(_vm._s(item[0]))])
  }), 0)])]), _vm._v(" "), _c('table', {
    staticClass: "ushk-table_body"
  }, [_c('colgroup', _vm._l((_vm.items), function(item, index) {
    return _c('col', {
      key: index,
      attrs: {
        "width": item[1]
      }
    })
  }), 0), _vm._v(" "), _c('tbody', [(!_vm.datas) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("加载中......")])]) : [(_vm.datas.length) ? _vm._l((_vm.datas), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(data.pub_time.split(' ')[0]))]), _vm._v(" "), (_vm.isList) ? _c('td', [_c('button', {
      staticClass: "ushk-report__name",
      on: {
        "click": function($event) {
          return _vm.showReport(data)
        }
      }
    }, [_vm._v(_vm._s(data.name))])]) : _vm._e(), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(data.previous_rating))]), _vm._v(" "), (data.previous_rating && data.latest_rating) ? _c('icon', {
      attrs: {
        "type": "arrow"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.latest_rating))])], 1), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(data.previous_target_price || ''))]), _vm._v(" "), (data.previous_target_price && data.latest_target_price) ? _c('icon', {
      class: parseInt(data.previous_target_price) > parseInt(data.latest_target_price) ? 'is-green' : 'is-red',
      attrs: {
        "type": "arrow"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.latest_target_price || ''))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.institution))])])
  }) : _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.noneText))])])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ushk-more"
  }, [(_vm.isShowMore) ? _c('a', {
    staticClass: "ushk-more__btn",
    class: {
      'is-loading': _vm.isLoading
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.lower
    }
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_expand"
  }), _vm._v("点击加载更多")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("3sgj");


/***/ }),

/***/ "9LQW":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("mfTF"),
  /* template */
  __webpack_require__("0GbP"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "9eTL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-3.8d38244.png";

/***/ }),

/***/ "DFiJ":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("3I1u"),
  /* template */
  __webpack_require__("yMad"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_USER; });
var UPDATE_USER = 'UPDATE_USER';

/***/ }),

/***/ "ENaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getData__ = __webpack_require__("U+nj");





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: String,
    border: Boolean,
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      noneText: '暂无数据',
      limit: 0,
      items: [],
      datas: false,
      isShowMore: false,
      isLoading: false,
      offset: undefined
    };
  },

  computed: {
    isList: function isList() {
      return !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.data).length && !this.data.name;
    },
    unit: function unit() {
      return this.type === 'us' ? '美元' : '港币';
    }
  },
  mounted: function mounted() {
    var _this = this;

    var payload = { type: this.type };
    if (this.isList) {
      this.items = [['日期', '15%'], ['个股名称', '20%'], ['评级', '25%'], ['\u76EE\u6807\u4EF7\uFF08' + this.unit + '\uFF09', '20%'], ['机构名称', '20%']];
    } else {
      this.items = [['日期', '20%'], ['评级', '30%'], ['\u76EE\u6807\u4EF7\uFF08' + this.unit + '\uFF09', '25%'], ['机构名称', '25%']];
      payload.indicatorId = this.data.indicator_id;
    }
    this.getData(payload).then(function (_ref) {
      var list = _ref.list;

      _this.datas = list;
    });
  },

  methods: {
    getData: function getData(payload) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.isLoading = true;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getData__["a" /* default */])(payload).then(function (res) {
          _this2.isLoading = false;
          if (res.status !== 200) {
            reject();
            return false;
          }
          var data = res.data;

          _this2.offset = data.offset;
          _this2.isShowMore = data.list.length >= _this2.limit;
          resolve(data);
        }).catch(function () {
          _this2.isLoading = false;
        });
      });
    },
    lower: function lower() {
      var _this3 = this;

      var indicatorId = void 0;
      var lastDate = void 0;
      var offset = this.offset;
      var length = this.datas.length;
      if (!this.isList) {
        indicatorId = this.data.indicator_id;
      }
      if (length) {
        var lastData = this.datas[length - 1];
        lastDate = lastData.pub_time.split(' ')[0];
      }
      this.getData({
        type: this.type,
        indicatorId: indicatorId,
        lastDate: lastDate,
        offset: offset
      }).then(function (_ref2) {
        var list = _ref2.list;

        _this3.datas = _this3.datas.concat(list);
      });
    },
    showReport: function showReport(data) {
      this.$emit('show-report', {
        data: data,
        type: this.type
      });
    }
  }
});

/***/ }),

/***/ "FBzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home__ = __webpack_require__("DFiJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_home__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'appStatic',
  computed: {},
  components: {
    Home: __WEBPACK_IMPORTED_MODULE_0__pages_home___default.a
  },
  created: function created() {}
});

/***/ }),

/***/ "HapT":
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__("gLNj")
}
var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("FBzV"),
  /* template */
  __webpack_require__("He37"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "He37":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk ushk-calendar",
    attrs: {
      "id": "J_ushk"
    }
  }, [_c('div', {
    staticClass: "ushk-container"
  }, [_c('div', {
    staticClass: "ushk-box"
  }, [_c('ushk-header'), _vm._v(" "), _c('div', {
    staticClass: "ushk-page"
  }, [_c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('home')], 1)])], 1), _vm._v(" "), _c('ushk-footer')], 1), _vm._v(" "), _c('backtop')], 1)
},staticRenderFns: []}

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_home__ = __webpack_require__("xQAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_video__ = __webpack_require__("qLZl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_calendar__ = __webpack_require__("Tmzm");









if (false) {
  Vue.use(Vuex);
}

var state = {
  user: {},
  isVideoPlaying: false,
  videoType: 'index'
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  modules: {
    home: __WEBPACK_IMPORTED_MODULE_5__modules_home__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_6__modules_video__["a" /* default */],
    calendar: __WEBPACK_IMPORTED_MODULE_7__modules_calendar__["a" /* default */]
  }
}));

/***/ }),

/***/ "MA7u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/accessData.501faa3.jpg";

/***/ }),

/***/ "Tmzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_headers__ = __webpack_require__("+mDD");





var state = {
  stockAffect: {}
};

var getters = {
  stockAffect: function stockAffect(state) {
    return state.stockAffect;
  }
};

var actions = {
  getStockAffect: function getStockAffect(_ref) {
    var _this = this;

    var commit = _ref.commit;
    var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    console.log(date);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this.isLoading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_fetch__["a" /* fetch */])({
        url: __WEBPACK_IMPORTED_MODULE_2__commons_config__["a" /* requestUrl */].rili.stockAffect,
        params: {
          date: date
        },
        headers: __WEBPACK_IMPORTED_MODULE_3__commons_headers__["a" /* calendarHeaders */],
        type: 'GET',

        useJson: true,

        callback: function callback(_ref2) {
          var data = _ref2.data;

          commit('SET_STOCK_AFFECT', data);
          resolve(data);
        },
        success: function success(_ref3) {
          var data = _ref3.data;

          commit('SET_STOCK_AFFECT', data);
          resolve(data);
        },
        error: function error() {
          reject();
        }
      });
    });
  }
};

var mutations = {
  SET_STOCK_AFFECT: function SET_STOCK_AFFECT(state, data) {
    state.stockAffect = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "U+nj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commons_fetch__ = __webpack_require__("yR7j");


var getData = function getData(_ref) {
  var type = _ref.type,
      indicatorId = _ref.indicatorId,
      lastDate = _ref.lastDate,
      offset = _ref.offset;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__commons_fetch__["a" /* fetch */])({
      url: 'https://calendar-api.ushknews.com/getWebTargetPriceList',
      type: 'get',
      useJson: true,
      headers: {
        'x-version': '1.0.0',
        'x-app-id': 'BNsiR9uq7yfW0LVz'
      },
      params: {
        limit: 20,
        category: type,
        indicator_id: indicatorId,
        date: lastDate,
        offset: offset
      },
      callback: function callback(res) {
        resolve(res);
      },
      error: function error() {
        reject();
      }
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getData);

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogin", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReadname", function() { return isReadname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVideoPlaying", function() { return isVideoPlaying; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "videoType", function() { return videoType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


var user = function user(state) {
  return state.user;
};

var options = function options(state) {
  return state.options;
};

var isLogin = function isLogin(state) {
  return !!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.user).length;
};

var isReadname = function isReadname(state, getters) {
  return getters.isLogin && state.user.cert.name && state.user.cert.status === 1;
};

var isVideoPlaying = function isVideoPlaying(state) {
  return state.isVideoPlaying;
};

var videoType = function videoType(state) {
  return state.videoType;
};

/***/ }),

/***/ "Uq1x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kexinwangzhan.fcb135b.png";

/***/ }),

/***/ "VwCb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-sm.655b81d.png";

/***/ }),

/***/ "WfM0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-calendar.f2fd14f.png";

/***/ }),

/***/ "ZQHk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-2.87e96ed.png";

/***/ }),

/***/ "fTYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "feRo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/renzhenglianmeng.4c9faf7.png";

/***/ }),

/***/ "gBM3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kexinwangzhan@2x.68a19e0.png";

/***/ }),

/***/ "gLNj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showLogin", function() { return showLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_fetch__ = __webpack_require__("yR7j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons__ = __webpack_require__("N4+L");






var getUser = function getUser(_ref) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_fetch__["a" /* fetch */])({
      type: 'jsonp',
      url: __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].ucenterInfo,
      showError: false,
      success: function success(response) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], response.data);
        resolve(response);
      },
      fail: function fail(response) {
        reject(response);
      }
    });
  });
};

var isShowLogin = false;
var showLogin = function showLogin(_ref2, type) {
  var commit = _ref2.commit;

  if (isShowLogin) {
    return false;
  }
  isShowLogin = true;
  setTimeout(function () {
    isShowLogin = false;
  }, 1000);
  type = type || 'login';
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__commons__["a" /* showLoginBox */])({
      embedded: type === 'embedded',
      loginCallback: function loginCallback(datas) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], datas.data);
        resolve();
      },
      oauthCallback: function oauthCallback() {
        getUser({ commit: commit }).then(function () {
          resolve();
        });
      },

      type: type === 'embedded' ? 'login' : type
    });
  });
};

/***/ }),

/***/ "mdX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Content__ = __webpack_require__("qxsW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReportDialog__ = __webpack_require__("9LQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReportDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ReportDialog__);



var components = {
  ReportContent: __WEBPACK_IMPORTED_MODULE_1__Content___default.a,
  ReportDialog: __WEBPACK_IMPORTED_MODULE_2__ReportDialog___default.a
};

function install(Vue) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).forEach(function (key) {
    Vue.component(key, components[key]);
  });
}

/***/ }),

/***/ "mfTF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: '',
  props: {
    data: Object,
    type: String,
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: this.value
    };
  },

  watch: {
    value: function value(v) {
      this.visible = v;
    },
    visible: function visible(v) {
      this.$emit('input', v);
    }
  }
});

/***/ }),

/***/ "pNk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    function documentHandler(e) {
      if (el.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        binding.value(e);
      }
    }
    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update: function update() {},
  unbind: function unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
});

/***/ }),

/***/ "qLZl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commons_utils__ = __webpack_require__("j+bc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commons_config__ = __webpack_require__("13m2");





var state = {

  list: [],
  isListEnd: false,
  orgList: []
};

var getters = {
  list: function list(state) {
    return state.list;
  },
  isListEnd: function isListEnd(state) {
    return state.isListEnd;
  }
};

var actions = {
  getList: function getList(_ref, _ref2) {
    var commit = _ref.commit;
    var page = _ref2.page,
        type = _ref2.type,
        onCompleted = _ref2.onCompleted;


    var me = this;

    if (page == 1) {

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        var url = __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].video.list(page, type);

        window['JQ_3c42cf2edf105ad172a61c9eef7097cc'] = window['JQ_8dfb823cd98999b77e04d61deabdb4e4'] = window["JQ_2f906963abfa705c491a32911aa449ff"] = window['JQ_8a2783ae91350e5b3078ee73418dcf1e'] = function (data) {
          data.map(function (item) {

            item.isHover = false;
            item.isPlayer = false;
            item.lazyImage = "//cdn.jin10.com/assets/img/sites/video/lazy-bg.png";
            item.isShow = false;
            item.imgUrl2 = __WEBPACK_IMPORTED_MODULE_3__commons_config__["a" /* requestUrl */].video.getEffect(item.id);
            item.isPause = true;
            item.isReset = false;
            item.isShowDesc = true;
            item.scrollTop = 0;
          });
          me.state.orgList = data;

          commit('getList', {
            data: data,
            page: page,
            onCompleted: onCompleted
          });

          resolve(data);
        };

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__commons_utils__["a" /* addScript */])(url, function (argument) {});
      });
    } else {
      commit('getList', {
        data: me.state.orgList,
        page: page,
        onCompleted: onCompleted
      });
    }
  }
};

var pageSize = 10;

var mutations = {
  getList: function getList(state, _ref3) {
    var data = _ref3.data,
        page = _ref3.page,
        onCompleted = _ref3.onCompleted;

    state.orgList = data;
    var newData = state.orgList.concat([]);

    if (page * pageSize >= state.orgList.length) {

      state.list = state.orgList;
      state.isListEnd = true;
    } else {
      newData.length = page * pageSize;
      state.list = newData;
      state.isListEnd = false;
    }

    if (onCompleted) {

      onCompleted(data);
    }
  },
  isItemShow: function isItemShow(state, index) {

    return state.list[index].isShow;
  },
  setItemShow: function setItemShow(state, index) {

    if (!state.list[index].isShow) {
      state.list[index].isShow = true;
    }
  },
  setItemScrollTop: function setItemScrollTop(state, _ref4) {
    var index = _ref4.index,
        scrollTop = _ref4.scrollTop;

    state.list[index].scrollTop = scrollTop;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "qNZ7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/certification.1c5d039.png";

/***/ }),

/***/ "qxsW":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("ENaQ"),
  /* template */
  __webpack_require__("5FRL"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ufEw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon-4.550c545.png";

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _types$UPDATE_USER$se;


/* harmony default export */ __webpack_exports__["a"] = (_types$UPDATE_USER$se = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* UPDATE_USER */], function (state, datas) {
  state.user = datas;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, 'setVideoState', function setVideoState(state, isVideoPlaying) {

  state.isVideoPlaying = isVideoPlaying;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_types$UPDATE_USER$se, 'setVideoType', function setVideoType(state, type) {

  state.videoType = type;
}), _types$UPDATE_USER$se);

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wTUH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/renzhenglianmeng@2x.828f805.png";

/***/ }),

/***/ "xQAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__("Du/2");


var state = {};

var getters = {};

var actions = {};

var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "yMad":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-content"
  }, [_c('div', {
    staticClass: "ushk-main ushk-content-box"
  }, [_c('div', {
    staticClass: "ushk-report"
  }, [_c('div', {
    staticClass: "ushk-report__h"
  }, [_c('jin-tabs', {
    staticClass: "ushk-report-tab",
    model: {
      value: (_vm.tabActive),
      callback: function($$v) {
        _vm.tabActive = $$v
      },
      expression: "tabActive"
    }
  }, [_c('jin-tab-pane', {
    attrs: {
      "label": "美股目标价",
      "name": "us"
    }
  }, [_c('report-content', {
    attrs: {
      "type": "us"
    },
    on: {
      "show-report": _vm.showReport
    }
  })], 1), _vm._v(" "), _c('jin-tab-pane', {
    attrs: {
      "label": "港股目标价",
      "name": "hk"
    }
  }, [(_vm.initHkTab) ? _c('report-content', {
    attrs: {
      "type": "hk"
    },
    on: {
      "show-report": _vm.showReport
    }
  }) : _vm._e()], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-side"
  }, [_c('div', {
    staticClass: "ushk-side__wrap"
  }, [_c('ad', {
    attrs: {
      "paddingTop": false
    }
  }), _vm._v(" "), _c('Declatration'), _vm._v(" "), _c('contract')], 1)]), _vm._v(" "), (_vm.curData) ? _c('report-dialog', {
    attrs: {
      "data": _vm.curData,
      "type": _vm.curType
    },
    model: {
      value: (_vm.isShowDialog),
      callback: function($$v) {
        _vm.isShowDialog = $$v
      },
      expression: "isShowDialog"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

},[6]);


// WEBPACK FOOTER //
// static/js/report.4c13cdc9769aa3987ff8.js